import * as TabsPrimitive from '@radix-ui/react-tabs'
import {
	forwardRef,
	type ElementRef,
	type ComponentPropsWithoutRef,
} from 'react'

import { cn } from '#app/utils/misc'

const Tabs = TabsPrimitive.Root

type TabsListProps = ComponentPropsWithoutRef<typeof TabsPrimitive.List> & {
	scrollable?: boolean
}

const TabsList = forwardRef<
	ElementRef<typeof TabsPrimitive.List>,
	TabsListProps
>(({ className, scrollable: _scrollable, ...props }, ref) => (
	<div className="border-b">
		<div className="overflow-x-auto">
			<TabsPrimitive.List
				ref={ref}
				className={cn('flex min-w-max space-x-8', className)}
				{...props}
			/>
		</div>
	</div>
))
TabsList.displayName = TabsPrimitive.List.displayName

const TabsTrigger = forwardRef<
	ElementRef<typeof TabsPrimitive.Trigger>,
	ComponentPropsWithoutRef<typeof TabsPrimitive.Trigger>
>(({ className, ...props }, ref) => (
	<TabsPrimitive.Trigger
		ref={ref}
		className={cn(
			'text-muted-foreground hover:text-foreground data-[state=active]:border-primary data-[state=active]:text-primary border-b-2 border-transparent px-1 py-1 text-sm font-medium whitespace-nowrap transition-colors hover:cursor-pointer hover:border-gray-300',
			className,
		)}
		{...props}
	/>
))
TabsTrigger.displayName = TabsPrimitive.Trigger.displayName

const TabsContent = forwardRef<
	ElementRef<typeof TabsPrimitive.Content>,
	ComponentPropsWithoutRef<typeof TabsPrimitive.Content>
>(({ className, ...props }, ref) => (
	<TabsPrimitive.Content
		ref={ref}
		className={cn(
			'ring-offset-background focus-visible:ring-ring mt-2 focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:outline-none',
			className,
		)}
		{...props}
	/>
))
TabsContent.displayName = TabsPrimitive.Content.displayName

export { Tabs, TabsList, TabsTrigger, TabsContent }
